<template>
  <div>
    <meeting-desktop v-if="screenType === 'desktop'" ></meeting-desktop>
    <meeting-mobile v-else></meeting-mobile>
  </div>
</template>

<script>
import MeetingDesktop from "@/components/Pages/Desktop/Dashboard/Sessions/MeetingDesktop";
import MeetingMobile from "@/components/Pages/Mobile/Dashboard/Sessions/MeetingMobile";

export default {
  name: "MeetingMain",
  components: {MeetingMobile, MeetingDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>